
























import {
  computed,
  defineComponent, PropType, useContext,
} from '@nuxtjs/composition-api';

import { useMagentoConfiguration, useTax } from '~/composables';
import { smoothScrollToElement } from '~/helpers/smoothScrollToElement';
import { AlternativeProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'ProductArrow',
  props: {
    altProduct: {
      type: [Object, null] as PropType<AlternativeProductInterface | null>,
      default: null,
    },
  },

  setup(props) {
    const { app } = useContext();
    const { taxState } = useTax();
    const { getPriceWithCurrency } = useMagentoConfiguration();

    const arrowText = computed(() => {
      const priceDiff = taxState.value
        ? getPriceWithCurrency(props.altProduct.price_difference_incl_tax)
        : getPriceWithCurrency(props.altProduct.price_difference);

      if (props.altProduct.arrow_rule === 1) {
        return app.i18n.t('Print {yieldDiff}% more and save {priceDiff}', { priceDiff, yieldDiff: props.altProduct.yields_difference });
      }

      if (props.altProduct.arrow_rule === 2) {
        return app.i18n.t('Print {yieldDiff}% more for only {priceDiff}', { priceDiff, yieldDiff: props.altProduct.yields_difference });
      }

      // Same capacity
      return app.i18n.t('Save {priceDiff}', { priceDiff });
    });

    const scrollToBlock = () => {
      smoothScrollToElement('#cross-selling');
    };

    return {
      arrowText,
      scrollToBlock,
    };
  },
});
